<div class="live-view-container">
    <app-standalone-live-page [venueData]="venueData" [isEmbedded]="true" [venuesList]="venuesList"></app-standalone-live-page>
</div>
